var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInactivelist = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7730_16246",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7730_16246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.5192V9.5625H3.75V12.5192C3.75 12.5769 3.77406 12.6298 3.82219 12.6778C3.87019 12.7259 3.92306 12.75 3.98081 12.75H14.0192C14.0769 12.75 14.1298 12.7259 14.1778 12.6778C14.2259 12.6298 14.25 12.5769 14.25 12.5192ZM14.25 8.4375V5.48081C14.25 5.42306 14.2259 5.37019 14.1778 5.32219C14.1298 5.27406 14.0769 5.25 14.0192 5.25H3.98081C3.92306 5.25 3.87019 5.27406 3.82219 5.32219C3.77406 5.37019 3.75 5.42306 3.75 5.48081V8.4375H14.25ZM3.98081 13.875C3.60194 13.875 3.28125 13.7438 3.01875 13.4813C2.75625 13.2188 2.625 12.8981 2.625 12.5192V5.48081C2.625 5.10194 2.75625 4.78125 3.01875 4.51875C3.28125 4.25625 3.60194 4.125 3.98081 4.125H14.0192C14.3981 4.125 14.7188 4.25625 14.9813 4.51875C15.2438 4.78125 15.375 5.10194 15.375 5.48081V12.5192C15.375 12.8981 15.2438 13.2188 14.9813 13.4813C14.7188 13.7438 14.3981 13.875 14.0192 13.875H3.98081Z",
    fill: "#1E293B"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInactivelist);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/inactivelist.07f4126ef7dd05080d3df5001316eca7.svg";